/** 
 * web-auth SDK 유저 관련 모듈
 */
import InfaceUserProfile from './inface-user-profile.class'

function isObject(obj) {
  return typeof obj === "object" && obj !== null
}

class InfaceUser {
  constructor({ profile = {} }) {
    this._profile = new InfaceUserProfile(profile)
  }

  get profile() {
    return this._profile
  }

  getProfile() {
    return this._profile
  }

  setProfile(value) {
    if (!isObject(value)) return
    this._profile = new InfaceUserProfile({ ...this._profile, ...value })
  }
}

export default InfaceUser